import region from './region';

export const isProd: boolean = process.env.NODE_ENV !== 'development';

export const IS_PRODUCTION_ENV: boolean = process.env.NEXT_PUBLIC_IA_ENV === 'production';

export const basePath: string = process.env.PUBLIC_URL || '';
export const PUBLIC_URL: string = process.env.NEXT_PUBLIC_PUBLIC_URL || '';

export const isMockingEnvEnabled =
  process.env.NEXT_PUBLIC_MOCKS_ENABLED && process.env.NEXT_PUBLIC_IA_ENV === 'development';

export const US_BASE_API: string | undefined = process.env.NEXT_PUBLIC_US_API_BASE_URL;
export const BASE_API: string | undefined = process.env.NEXT_PUBLIC_API_BASE_URL;
export const ITEMS_SALES_BASE_URL: string | undefined = process.env.NEXT_PUBLIC_API_ITEMS_SALES_BASE_URL;

export const ITEMS_SALES_PUBLIC_TOKEN: string | undefined = process.env.NEXT_PUBLIC_ITEMS_SALES_PUBLIC_TOKEN;

export const SHOULD_FETCH_ORDER_ITEMS_DETAILS: string | undefined =
  process.env.NEXT_PUBLIC_SHOULD_FETCH_ORDER_ITEMS_DETAILS;

export const SENTRY_URL: string | undefined = process.env.NEXT_PUBLIC_SENTRY_DSN;

// Chat SDK script URL (chat.js) for the embedded survey chat agent — env-driven per environment.
export const MOMOS_CHAT_URL: string | undefined = process.env.NEXT_PUBLIC_MOMOS_CHAT_URL;

export const TERMS_AND_CONDITIONS_URL = 'https://www.momos.com/legal-pages';

// Language code to display name mapping (ISO 639) for T&C and other multilingual features
export const LANGUAGE_LABELS: Record<string, string> = {
  aa: 'Afaraf (Afar)',
  ab: 'аҧсуа бызшәа, аҧсшәа (Abkhaz)',
  ae: 'avesta (Avestan)',
  af: 'Afrikaans (Afrikaans)',
  ak: 'Akan (Akan)',
  am: 'አማርኛ (Amharic)',
  an: 'aragonés (Aragonese)',
  ar: 'العربية (Arabic)',
  as: 'অসমীয়া (Assamese)',
  av: 'авар мацӀ, магӀарул мацӀ (Avaric)',
  ay: 'aymar aru (Aymara)',
  az: 'azərbaycan dili (Azerbaijani)',
  ba: 'башҡорт теле (Bashkir)',
  be: 'беларуская мова (Belarusian)',
  bg: 'български език (Bulgarian)',
  bh: 'भोजपुरी (Bihari)',
  bi: 'Bislama (Bislama)',
  bm: 'bamanankan (Bambara)',
  bn: 'বাংলা (Bengali, Bangla)',
  bo: 'བོད་ཡིག (Tibetan Standard, Tibetan, Central)',
  br: 'brezhoneg (Breton)',
  bs: 'bosanski jezik (Bosnian)',
  ca: 'català (Catalan)',
  ce: 'нохчийн мотт (Chechen)',
  ch: 'Chamoru (Chamorro)',
  co: 'corsu, lingua corsa (Corsican)',
  cr: 'ᓀᐦᐃᔭᐍᐏᐣ (Cree)',
  cs: 'čeština, český jazyk (Czech)',
  cu: 'ѩзыкъ словѣньскъ (Old Church Slavonic, Church Slavonic, Old Bulgarian)',
  cv: 'чӑваш чӗлхи (Chuvash)',
  cy: 'Cymraeg (Welsh)',
  da: 'dansk (Danish)',
  de: 'Deutsch (German)',
  dv: 'ދިވެހި (Divehi, Dhivehi, Maldivian)',
  dz: 'རྫོང་ཁ (Dzongkha)',
  ee: 'Eʋegbe (Ewe)',
  el: 'ελληνικά (Greek (modern))',
  en: 'English (American)',
  'en-GB': 'English (British)',
  eo: 'Esperanto (Esperanto)',
  es: 'Español (Spanish)',
  et: 'eesti, eesti keel (Estonian)',
  eu: 'euskara, euskera (Basque)',
  fa: 'فارسی (Persian (Farsi))',
  ff: 'Fulfulde, Pulaar, Pular (Fula, Fulah, Pulaar, Pular)',
  fi: 'suomi, suomen kieli (Finnish)',
  fj: 'vosa Vakaviti (Fijian)',
  fo: 'føroyskt (Faroese)',
  fr: 'français, langue française (French)',
  fy: 'Frysk (Western Frisian)',
  ga: 'Gaeilge (Irish)',
  gd: 'Gàidhlig (Scottish Gaelic, Gaelic)',
  gl: 'galego (Galician)',
  gn: "Avañe'ẽ (Guaraní)",
  gu: 'ગુજરાતી (Gujarati)',
  gv: 'Gaelg, Gailck (Manx)',
  ha: '(Hausa) هَوُسَ (Hausa)',
  he: 'עברית (Hebrew (modern))',
  hi: 'हिन्दी, हिंदी (Hindi)',
  ho: 'Hiri Motu (Hiri Motu)',
  hr: 'hrvatski jezik (Croatian)',
  ht: 'Kreyòl ayisyen (Haitian, Haitian Creole)',
  hu: 'magyar (Hungarian)',
  hy: 'Հdelays (Armenian)',
  hz: 'Otjiherero (Herero)',
  ia: 'Interlingua (Interlingua)',
  id: 'Bahasa Indonesia (Indonesian)',
  ie: 'Originally called Occidental; then Interlingue after WWII (Interlingue)',
  ig: 'Asụsụ Igbo (Igbo)',
  ii: 'ꆈꌠ꒿ Nuosuhxop (Nuosu)',
  ik: 'Iñupiaq, Iñupiatun (Inupiaq)',
  io: 'Ido (Ido)',
  is: 'Íslenska (Icelandic)',
  it: 'Italiano (Italian)',
  iu: 'ᐃᓄᒃᑎᑐᑦ (Inuktitut)',
  ja: '日本語 (にほんご) (Japanese)',
  jv: 'ꦧꦱꦗꦮ, Basa Jawa (Javanese)',
  ka: 'ქართული (Georgian)',
  kg: 'Kikongo (Kongo)',
  ki: 'Gĩkũyũ (Kikuyu, Gikuyu)',
  kj: 'Kuanyama (Kwanyama, Kuanyama)',
  kk: 'қазақ тілі (Kazakh)',
  kl: 'kalaallisut, kalaallit oqaasii (Kalaallisut, Greenlandic)',
  km: 'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ (Khmer)',
  kn: 'ಕನ್ನಡ (Kannada)',
  ko: '한국어 (Korean)',
  kr: 'Kanuri (Kanuri)',
  ks: 'कश्मीरी, كشميري‎ (Kashmiri)',
  ku: 'Kurdî, كوردی‎ (Kurdish)',
  kv: 'коми кыв (Komi)',
  kw: 'Kernewek (Cornish)',
  ky: 'Кыргызча, Кыргыз тили (Kyrgyz)',
  la: 'latine, lingua latina (Latin)',
  lb: 'Lëtzebuergesch (Luxembourgish, Letzeburgesch)',
  lg: 'Luganda (Ganda)',
  li: 'Limburgs (Limburgish, Limburgan, Limburger)',
  ln: 'Lingála (Lingala)',
  lo: 'ພາສາລາວ (Lao)',
  lt: 'lietuvių kalba (Lithuanian)',
  lu: 'Tshiluba (Luba-Katanga)',
  lv: 'latviešu valoda (Latvian)',
  mg: 'fiteny malagasy (Malagasy)',
  mh: 'Kajin M̧ajeļ (Marshallese)',
  mi: 'te reo Māori (Māori)',
  mk: 'македонски јазик (Macedonian)',
  ml: 'മലയാളം (Malayalam)',
  mn: 'Монгол хэл (Mongolian)',
  mr: 'मराठी (Marathi (Marāṭhī))',
  ms: 'bahasa Melayu, بهاس ملايو‎ (Malay)',
  mt: 'Malti (Maltese)',
  my: 'ဗမာစာ (Burmese)',
  na: 'Dorerin Naoero (Nauruan)',
  nb: 'Norsk bokmål (Norwegian Bokmål)',
  nd: 'isiNdebele (Northern Ndebele)',
  ne: 'नेपाली (Nepali)',
  ng: 'Owambo (Ndonga)',
  nl: 'Nederlands, Vlaams (Dutch)',
  nn: 'Norsk nynorsk (Norwegian Nynorsk)',
  no: 'Norsk (Norwegian)',
  nr: 'isiNdebele (Southern Ndebele)',
  nv: 'Diné bizaad (Navajo, Navaho)',
  ny: 'chiCheŵa, chinyanja (Chichewa, Chewa, Nyanja)',
  oc: "occitan, lenga d'òc (Occitan)",
  oj: 'ᐊᓂᔑᓈᐯᒧᐎᓐ (Ojibwe, Ojibwa)',
  om: 'Afaan Oromoo (Oromo)',
  or: 'ଓଡ଼ିଆ (Oriya)',
  os: 'ирон æвзаг (Ossetian, Ossetic)',
  pa: 'ਪੰਜਾਬੀ ((Eastern) Punjabi)',
  pi: 'पाऴि (Pāli)',
  pl: 'język polski, polszczyzna (Polish)',
  ps: 'پښتو (Pashto, Pushto)',
  pt: 'Português (Portuguese)',
  qu: 'Runa Simi, Kichwa (Quechua)',
  rm: 'rumantsch grischun (Romansh)',
  rn: 'Ikirundi (Kirundi)',
  ro: 'Română (Romanian)',
  ru: 'Русский (Russian)',
  rw: 'Ikinyarwanda (Kinyarwanda)',
  sa: 'संस्कृतम् (Sanskrit (Saṁskṛta))',
  sc: 'sardu (Sardinian)',
  sd: 'सिन्धी, سنڌي، سندھی‎ (Sindhi)',
  se: 'Davvisámegiella (Northern Sami)',
  sg: 'yângâ tî sängö (Sango)',
  si: 'සිංහල (Sinhalese, Sinhala)',
  sk: 'slovenčina, slovenský jazyk (Slovak)',
  sl: 'slovenski jezik, slovenščina (Slovene)',
  sm: "gagana fa'a Samoa (Samoan)",
  sn: 'chiShona (Shona)',
  so: 'Soomaaliga, af Soomaali (Somali)',
  sq: 'Shqip (Albanian)',
  sr: 'српски језик (Serbian)',
  ss: 'SiSwati (Swati)',
  st: 'Sesotho (Southern Sotho)',
  su: 'Basa Sunda (Sundanese)',
  sv: 'svenska (Swedish)',
  sw: 'Kiswahili (Swahili)',
  ta: 'தமிழ் (Tamil)',
  te: 'తెలుగు (Telugu)',
  tg: 'тоҷикӣ, toçikī, تاجیکی‎ (Tajik)',
  th: 'ไทย (Thai)',
  ti: 'ትግርኛ (Tigrinya)',
  tk: 'Türkmen, Түркмен (Turkmen)',
  tl: 'Wikang Tagalog (Tagalog)',
  tn: 'Setswana (Tswana)',
  to: 'faka Tonga (Tonga (Tonga Islands))',
  tr: 'Türkçe (Turkish)',
  ts: 'Xitsonga (Tsonga)',
  tt: 'татар теле, tatar tele (Tatar)',
  tw: 'Twi (Twi)',
  ty: 'Reo Tahiti (Tahitian)',
  ug: 'ئۇيغۇرچە‎, Uyghurche (Uyghur)',
  uk: 'Українська (Ukrainian)',
  ur: 'اردو (Urdu)',
  uz: 'Oʻzbek, Ўзбек, أۇزبېك‎ (Uzbek)',
  ve: 'Tshivenḓa (Venda)',
  vi: 'Tiếng Việt (Vietnamese)',
  vo: 'Volapük (Volapük)',
  wa: 'walon (Walloon)',
  wo: 'Wollof (Wolof)',
  xh: 'isiXhosa (Xhosa)',
  yi: 'ייִדיש (Yiddish)',
  yo: 'Yorùbá (Yoruba)',
  za: 'Saɯ cueŋƅ, Saw cuengh (Zhuang, Chuang)',
  'zh-CN': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)',
  'zh-HK': 'Hong Kong (Traditional)',
  zu: 'isiZulu (Zulu)',
};

export const GA_TRACKING_ID: string | undefined = process.env.NEXT_PUBLIC_GA_ID;

// The US microsite exceeds one GA4 property's BigQuery Daily Export cap, so its traffic is split
// across two Analytics Properties (GEN-23787). Merchants listed here are recorded in the second one;
// everyone else stays on the default. Keep this list identical to SECONDARY_GA_PROPERTY_BRAND_SLUGS
// in momoshub-be — a slug on one side only puts that merchant's Browser and Server Events in
// different properties, which makes its funnel uncomputable.
export const GA_TRACKING_ID_2: string | undefined = process.env.NEXT_PUBLIC_GA_ID_2;

export const SECOND_GA_PROPERTY_SLUGS: string[] = [
  'burger-king-4ha34', // Burger King
];

// Falls back to the default property when the second one is not configured in this environment:
// recording in the wrong property is recoverable, but rendering no tag at all would lose every
// Browser Event for that merchant.
export const gaTrackingIdForBrandSlug = (brandSlug?: string): string | undefined => {
  const slug = brandSlug?.trim().toLowerCase();
  return slug && SECOND_GA_PROPERTY_SLUGS.includes(slug) && GA_TRACKING_ID_2 ? GA_TRACKING_ID_2 : GA_TRACKING_ID;
};

export const IS_ALLOWED_SURVEY_OBSERVABILITY: boolean =
  process.env.NEXT_PUBLIC_IS_ALLOWED_SURVEY_OBSERVABILITY == 'true';

export const REGIONS: Record<string, string> = {
  US: 'US',
  SG: 'SG',
};

export const REGION: string = process.env.NEXT_PUBLIC_REGION || REGIONS.SG;

export const DISTANCE_UNIT: string = REGION === REGIONS.US ? 'mi' : 'km';

export const MOMOS_WEBSITE_URL = 'https://momos.com/';

export const FACEBOOK_GRAPH_API_ACCESS_TOKEN: string | undefined =
  process.env.NEXT_PUBLIC_FACEBOOK_GRAPH_API_ACCESS_TOKEN;

export const REGION_PHONE = region;

export const SUBSCRIBE_TERMS_AND_CONDITIONS_URL = 'https://www.momos.com/us-privacy-policy';

export const DEFAULT_TS_TEXT = `<p>By checking this box, you agree to the following <a href="about:blank" rel="noopener noreferrer" target="_blank">Terms and Conditions</a> and agree to receive marketing communications from the merchant.</p>`;

export const DATE_FORMAT = 'MMMM DD, YYYY h:mm a'; //January 13, 2024 2:00 pm

export const LOCATION_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  CLOSED_PERMANENTLY: 'CLOSED_PERMANENTLY',
  CLOSED_TEMPORARILY: 'CLOSED_TEMPORARILY',
  DISCONNECTED: 'DISCONNECTED',
  OPEN_FOR_BUSINESS_UNSPECIFIED: 'OPEN_FOR_BUSINESS_UNSPECIFIED',
  LOCATION_UNDER_REVIEW: 'LOCATION_UNDER_REVIEW',
  DUPLICATE: 'DUPLICATE',
  NOT_LIVE: 'NOT_LIVE',
  DISABLED: 'DISABLED',
  SUSPENDED: 'SUSPENDED',
};

export const LOCATION_STATUS_INFO_TAG = {
  OPEN: 'Open Location',
  CLOSED: 'Closed Location',
  CLOSED_PERMANENTLY: 'Permanently Closed Location',
  CLOSED_TEMPORARILY: 'Temporarily Closed Location',
  ACTIVE: 'Active Location',
  DISCONNECTED: 'Disconnected Location',
  OPEN_FOR_BUSINESS_UNSPECIFIED: 'Open For Business',
  LOCATION_UNDER_REVIEW: 'Location Under Review',
  DUPLICATE: 'Duplicate Location',
  NOT_LIVE: 'Location Not Live',
  DISABLED: 'Disabled Location',
  SUSPENDED: 'Suspended Location',
};

// Datadog RUM Env Variables
export const DATADOG_APP_ID = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
export const DATADOG_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
export const DATADOG_RUM_SERVICE = process.env.NEXT_PUBLIC_DATADOG_RUM_SERVICE;
export const DATADOG_RUM_ENV = process.env.NEXT_PUBLIC_DATADOG_RUM_ENV;
export const DATADOG_RUM_DEPLOYMENT_VERSION = process.env.NEXT_PUBLIC_DATADOG_RUM_DEPLOYMENT_VERSION;
